import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { BrowserCacheLocation } from '@azure/msal-browser';

@Injectable({
    providedIn: 'root'
})
export class MsalStoragePolicyService {
    constructor(private platform: Platform) { }

    public get cacheLocation(): BrowserCacheLocation {
        return BrowserCacheLocation.LocalStorage;
    }

    public resolveConfiguredStorage(): Storage | undefined {
        if (!this.platform.isBrowser) {
            return undefined;
        }

        if (this.cacheLocation === BrowserCacheLocation.SessionStorage) {
            return typeof sessionStorage === 'undefined' ? undefined : sessionStorage;
        }

        if (this.cacheLocation === BrowserCacheLocation.LocalStorage) {
            return typeof localStorage === 'undefined' ? undefined : localStorage;
        }

        return undefined;
    }
}